module.exports = __webpack_public_path__ + "static/img/brees-2002-top-image.a9aa80f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2002-top-image.jpg
// module id = RXjf
// module chunks = 1